/* ================================================================
   RATEL SUPPLY — Common JavaScript
   - Loads header/footer partials via fetch (works for both file://
     and Shopify upload — Shopify replaces these with Liquid sections)
   - Hero carousel
   - FAQ accordion
   - Mobile hamburger
   ================================================================ */

(function () {
  'use strict';

  /* ---------- 1. PARTIALS LOADER ----------
     Looks for <div data-include="header"></div> and <div data-include="footer"></div>
     If running from file:// (no fetch), falls back to inlined partials below. */
  async function loadPartials() {
    const slots = document.querySelectorAll('[data-include]');
    if (!slots.length) return;
    for (const slot of slots) {
      const name = slot.getAttribute('data-include');
      try {
        const res = await fetch('partials/' + name + '.html');
        if (!res.ok) throw new Error('not ok');
        slot.outerHTML = await res.text();
      } catch (e) {
        // file:// fallback — use inlined partial from window.RATEL_PARTIALS
        if (window.RATEL_PARTIALS && window.RATEL_PARTIALS[name]) {
          slot.outerHTML = window.RATEL_PARTIALS[name];
        } else {
          console.warn('[Ratel] Could not load partial:', name);
        }
      }
    }
    afterPartialsLoaded();
  }

  function afterPartialsLoaded() {
    highlightActiveNav();
    bindHamburger();
  }

  /* ---------- 2. ACTIVE NAV HIGHLIGHT ---------- */
  function highlightActiveNav() {
    const key = document.body.getAttribute('data-page');
    if (!key) return;
    const link = document.querySelector('[data-nav-key="' + key + '"]');
    if (link) {
      link.classList.add('active');
      // On mobile, scroll the active nav link into view (centered) so users see context
      if (window.innerWidth <= 640) {
        try { link.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'auto' }); } catch (e) {}
      }
    }
  }

  /* ---------- 3. MOBILE HAMBURGER ---------- */
  function bindHamburger() {
    const burger = document.querySelector('.hamburger');
    const navbar = document.querySelector('.navbar');
    if (!burger || !navbar) return;
    burger.addEventListener('click', () => navbar.classList.toggle('open'));
  }

  /* ---------- 4. HERO CAROUSEL ---------- */
  function initHero() {
    const slides = document.querySelectorAll('.hero-slide');
    const dots = document.querySelectorAll('.hero-dot');
    if (!slides.length) return;
    let current = 0, timer;
    function goTo(i) {
      slides[current].classList.remove('active');
      dots[current] && dots[current].classList.remove('active');
      current = i;
      slides[current].classList.add('active');
      dots[current] && dots[current].classList.add('active');
    }
    function next() { goTo((current + 1) % slides.length); }
    function start() { timer = setInterval(next, 5000); }
    window.goSlide = function (i) { clearInterval(timer); goTo(i); start(); };
    start();
  }

  /* ---------- 5. FAQ ACCORDION ---------- */
  function initFAQ() {
    document.querySelectorAll('.faq-item').forEach(item => {
      const q = item.querySelector('.faq-q');
      if (!q) return;
      q.addEventListener('click', () => item.classList.toggle('open'));
    });
  }

  /* ---------- 6. PRODUCT GALLERY ---------- */
  function initGallery() {
    const main = document.querySelector('.product-gallery .main-img');
    const thumbs = document.querySelectorAll('.product-gallery .gallery-thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        thumbs.forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        const url = t.getAttribute('data-src') || t.style.backgroundImage;
        if (t.getAttribute('data-src')) {
          main.style.backgroundImage = "url('" + t.getAttribute('data-src') + "')";
        } else {
          main.style.backgroundImage = url;
        }
      });
    });
  }

  /* ---------- 7. STAT COUNTER ANIMATION ---------- */
  function initStats() {
    const stats = document.querySelectorAll('.stat-value[data-count]');
    if (!stats.length || !('IntersectionObserver' in window)) return;
    const animate = (el) => {
      const target = parseInt(el.getAttribute('data-count'), 10);
      const suffix = el.getAttribute('data-suffix') || '';
      const dur = 1400; const start = performance.now();
      const tick = (now) => {
        const t = Math.min(1, (now - start) / dur);
        const v = Math.floor(target * (0.5 - Math.cos(Math.PI * t) / 2));
        el.innerHTML = v.toLocaleString() + (suffix ? '<sup>' + suffix + '</sup>' : '');
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    stats.forEach(s => io.observe(s));
  }

  /* ---------- INIT ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    loadPartials().then(() => {
      initHero();
      initFAQ();
      initGallery();
      initStats();
      // Notify i18n (and any other modules) that header/footer DOM is ready
      document.dispatchEvent(new CustomEvent('ratel:partials-ready'));
    });
  });
})();
